import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgShowEvent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="2 -4 20 24" {...props}>
      <path
        d="M17.71 1.542l.028.147.122.776a3.977 3.977 0 011.841 2.104l.073.213 1.733 4.149c.286.63.455 1.326.455 2.064 0 2.76-2.225 5.005-4.958 5.005-2.395 0-4.4-1.723-4.86-4.005L12 12c-.062 0-.123-.003-.184-.008C11.36 14.275 9.354 16 6.958 16 4.225 16 2 13.755 2 10.995c0-.646.13-1.26.353-1.825l.101-.24 1.733-4.148a3.98 3.98 0 011.724-2.208l.191-.11.122-.775A1.985 1.985 0 018.493.025a2.001 2.001 0 011.667 2.142l-.018.149-.049.312c.301.196.572.432.807.702.314-.208.693-.33 1.1-.33.397 0 .766.115 1.077.315.173-.198.366-.378.576-.536l.216-.151-.049-.312A2 2 0 0115.468.025a1.986 1.986 0 012.242 1.517zm-.706 6.449c-1.64 0-2.976 1.348-2.976 3.004 0 1.655 1.335 3.003 2.976 3.003 1.64 0 2.974-1.348 2.974-3.003 0-1.656-1.334-3.004-2.974-3.004zm-10.046 0c-1.641 0-2.975 1.348-2.975 3.004 0 1.655 1.334 3.003 2.975 3.003s2.975-1.348 2.975-3.003c0-1.656-1.334-3.004-2.975-3.004zM12 7a1 1 0 100 2 1 1 0 000-2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('ShowEvent')(SvgShowEvent);
